// The one place the "already sent" key shape is defined; `sentPairKeys` holds these.
export const buildPairKey = (applicationId: number, questionnaireId: number) => `${applicationId}:${questionnaireId}`;

// ponytail: module singleton over Context — one consumer tree (matching pages, steps 03–05),
// zero cross-cutting subscribers; upgrade to Context only if a component outside the matching
// pages ever needs live updates. Cleared by module re-evaluation on reload — that IS AC-9's
// "empty state on reload"; do not add reset/persistence logic.
//
// Consumers beyond this step: step 04's loader reads `runId`; step 05's "run again" path
// re-enters this page with the store intact.
export const matchingSession: { selectedQuestionnaireIds: number[]; runId: string | null; sentPairKeys: string[] } = {
  selectedQuestionnaireIds: [],
  runId: null,
  // "Already sent" cue (PLAN §4.13) — page-session only, no persisted `MatchConfirmation` row (P5
  // no-persistence ruling). Keyed `"<applicationId>:<questionnaireId>"`.
  sentPairKeys: [],
};
